import React, { useMemo } from "react";
import { Link, useHistory } from "react-router-dom";

import { Box, Typography } from "@material-ui/core";
import ContentAdd from "@material-ui/icons/Add";
import AiIcon from "@material-ui/icons/AssistantOutlined";

import { Button } from "react-admin";
import { useTranslate } from "ra-core";

import { isSubscriptionDisabled } from "../../../utils/appUtils";

export const EmptyInbound = ({
  basePath,
  resource,
  message,
  backPath,
  state,
  hasCreate = true,
  ...props
}) => {
  return (
    <Box textAlign="center" m={1}>
      <Typography variant="body1" gutterBottom>
        {message}
      </Typography>
      {hasCreate && (
        <>
          {!state?.sit && (
            <CreateAdviceButton
              {...props}
              basePath={basePath}
              resource={resource}
              backPath={backPath}
              state={state}
              disabled={isSubscriptionDisabled()}
            />
          )}
          <CreateButton
            {...props}
            basePath={basePath}
            resource={resource}
            backPath={backPath}
            state={state}
            disabled={isSubscriptionDisabled()}
          />
        </>
      )}
    </Box>
  );
};

const CreateButton = (props) => {
  const {
    basePath = "",
    resource,
    backPath,
    state = {},
    className,
    label = "ra.action.create",
    scrollToTop = true,
    variant,
    ...rest
  } = props;
  const history = useHistory();
  const translate = useTranslate();

  const location = useMemo(
    () => ({
      pathname: basePath ? `${basePath}/create` : `/${resource}/create`,
      state: {
        ...state,
        backPath: backPath
          ? [...backPath, history.location.pathname]
          : [history.location.pathname],
        _scrollToTop: scrollToTop,
      },
    }),
    [basePath, resource, backPath, state, history, scrollToTop],
  );

  return (
    <Button
      component={Link}
      to={location}
      className={className}
      label={translate(label)}
      variant={variant}
      {...rest}
    >
      <ContentAdd />
    </Button>
  );
};

const CreateAdviceButton = (props) => {
  const {
    basePath = "",
    resource,
    backPath,
    state = {},
    className,
    scrollToTop = true,
    variant,
  } = props;
  const history = useHistory();

  const advicePath = useMemo(
    () => ({
      pathname: basePath ? `${basePath}/create` : `/${resource}/create`,
      search: "?advice",
      state: {
        ...state,
        entryPoint: "advices",
        backPath: backPath
          ? [...backPath, history.location.pathname]
          : [history.location.pathname],
        _scrollToTop: scrollToTop,
      },
    }),
    [basePath, resource, backPath, state, history, scrollToTop],
  );

  return (
    <Button
      component={Link}
      to={advicePath}
      className={className}
      label={"Advice"}
      variant={variant}
    >
      <AiIcon />
    </Button>
  );
};
